<template>
  <el-dialog
    v-model="dialogStatus"
    :close-on-click-modal="false"
    @close="close"
    :title="dialogTitle"
    :width="width"
    append-to-body>
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="渠道名称" prop="channelName">
        <el-input v-model="form.channelName" size="medium" placeholder="请输入渠道名称" />
      </el-form-item>
      <el-form-item label="自定义Uri" prop="customFeedbackUrlOnoff">
        <el-switch
          v-model="form.customFeedbackUrlOnoff"
          :active-value="1"
          :inactive-value="0"
          @change="handleFeedbackSwitchChange"
        />
      </el-form-item>
      <el-form-item label="Uri" prop="feedbackUri">
        <el-input
          v-model="form.feedbackUri"
          size="medium"
          placeholder="请输入渠道 feedbackUri"
          :disabled="form.customFeedbackUrlOnoff === 0"
          type="textarea"
          :rows="3"
        />
      </el-form-item>
      <el-form-item label="描述" prop="description">
        <el-input
          v-model="form.description"
          type="textarea"
          :rows="3"
          size="medium"
          placeholder="请输入渠道描述"
        />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio :label="0">禁用</el-radio>
          <el-radio :label="1">启用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div style="text-align: right;">
      <el-button @click="close" size="medium">取消</el-button>
      <el-button @click="submit" type="primary" size="medium" :loading="submitLoading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addChannel, updateChannel } from '@/api/ocpx/channel'

const defaultForm = {
  channelName: undefined,
  channelCode: undefined,
  description: undefined,
  customFeedbackUrlOnoff: 0,
  feedbackUri: '/ocpx/feedback?event=CLICK&ip=__IP__&ipv6=__IPV6__&android_id=__ANDROIDID__&android_idmd5=__ANDROIDID_MD5__&imei=__IMEI__&imei_md5=__IMEI_MD5__&idfa=__IDFA__&idfa_md5=__IDFA_MD5__&caid=__CAID__&oaid=__OAID__&oaid_md5=__OAID_MD5__&aaid=__AAID__&ua=__UA__&os=__OS__&model=__MODEL__&callback=__CALLBACK__&clickid=__CLICKID__&advertiser_id=__ADVERTISERID__&campaign_id=__PLANID__&channel_id=__CHANNELID__&task_id=__TASKID__&creative_id=__CREATIVEID__&mac=__MAC__',
  status: 1
}

export default {
  props: {
    title: String,
    width: {
      type: Number,
      default: 600
    }
  },
  emits: ['submit'],
  data () {
    return {
      dialogStatus: false,
      submitLoading: false,
      form: Object.assign({}, defaultForm),
      rules: {
        channelName: [{ required: true, message: '请输入渠道名称', trigger: 'blur' }]
      }
    }
  },
  computed: {
    dialogTitle () {
      return (this.title ? this.title : '') + (this.form.id ? '编辑' : '新增')
    }
  },
  methods: {
    handleFeedbackSwitchChange (val) {
      if (val === 0) {
        // 关闭时恢复默认值
        this.form.feedbackUri = '/ocpx/feedback?event=CLICK&ip=__IP__&ipv6=__IPV6__&android_id=__ANDROIDID__&android_idmd5=__ANDROIDID_MD5__&imei=__IMEI__&imei_md5=__IMEI_MD5__&idfa=__IDFA__&idfa_md5=__IDFA_MD5__&caid=__CAID__&oaid=__OAID__&oaid_md5=__OAID_MD5__&aaid=__AAID__&ua=__UA__&os=__OS__&model=__MODEL__&callback=__CALLBACK__&clickid=__CLICKID__&advertiser_id=__ADVERTISERID__&campaign_id=__PLANID__&channel_id=__CHANNELID__&task_id=__TASKID__&creative_id=__CREATIVEID__&mac=__MAC__'
      }
    },
    show (data) {
      this.dialogStatus = true
      if (data) {
        this.form = Object.assign({}, data)
        // 如果没有设置 feedbackUri，使用默认值
        if (!this.form.feedbackUri && this.form.customFeedbackUrlOnoff === 0) {
          this.form.feedbackUri = '/ocpx/feedback?event=CLICK&ip=__IP__&ipv6=__IPV6__&android_id=__ANDROIDID__&android_idmd5=__ANDROIDID_MD5__&imei=__IMEI__&imei_md5=__IMEI_MD5__&idfa=__IDFA__&idfa_md5=__IDFA_MD5__&caid=__CAID__&oaid=__OAID__&oaid_md5=__OAID_MD5__&aaid=__AAID__&ua=__UA__&os=__OS__&model=__MODEL__&callback=__CALLBACK__&clickid=__CLICKID__&advertiser_id=__ADVERTISERID__&campaign_id=__PLANID__&channel_id=__CHANNELID__&task_id=__TASKID__&creative_id=__CREATIVEID__&mac=__MAC__'
        }
      }
    },
    close () {
      this.dialogStatus = false
      this.reset()
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.id) {
            this.doUpdate(this.form)
          } else {
            this.doAdd(this.form)
          }
        }
      })
    },
    doAdd (form) {
      this.submitLoading = true
      addChannel(form).then(res => {
        if (res.code === 200) {
          this.$message.success('新增成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    doUpdate (form) {
      this.submitLoading = true
      updateChannel(form).then(res => {
        if (res.code === 200) {
          this.$message.success('编辑成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    reset () {
      this.form = Object.assign({}, defaultForm)
      this.$refs.form && this.$refs.form.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 15px;
}
</style>
